import { useParams } from 'react-router-dom'
import Activities from '@/components/Activities'
import {
    getLocationLogs,
    getRackLogs,
    getEquipmentLogs,
    getComponentLogs,
} from '../../services'
import { ActivityPayload } from '../../types'

export type EntityType = 'rack' | 'equipment' | 'component' | 'location'

interface ActivityLogsProps {
    entityType: EntityType
}

/**
 * ActivityLogs - Displays activity logs for warehouse entities
 * Uses the shared Activities component for consistent UI across the app
 */
const ActivityLogs = ({ entityType }: ActivityLogsProps) => {
    const { id } = useParams<{ id: string }>()

    // Get the appropriate API call based on entity type
    const getApiCall = () => {
        switch (entityType) {
            case 'location':
                return (payload: ActivityPayload) =>
                    getLocationLogs({ location_id: id!, params: payload })
            case 'rack':
                return (payload: ActivityPayload) =>
                    getRackLogs({ rack_id: id!, params: payload })
            case 'equipment':
                return (payload: ActivityPayload) =>
                    getEquipmentLogs({ equipment_id: id!, params: payload })
            case 'component':
                return (payload: ActivityPayload) =>
                    getComponentLogs({ component_id: id!, params: payload })
        }
    }

    return (
        <div className="mt-2">
            <Activities
                apiCall={getApiCall()}
                queryKey={`${entityType}-logs-${id}`}
                translationNamespace="warehouse"
            />
        </div>
    )
}

export default ActivityLogs
